import React from "react";
import { Select } from "antd";
// import "./Filters.css";

const { Option } = Select;

const FilterDates = ({ onDateChange, disabled }) => {
  const onChange = async (value, key) => {
    await onDateChange(key.key);
    // console.log(key.key);
  };

  return (
    <div className="filter-groups">
      <Select
        className="add-business-section"
        defaultValue="7 derniers jours"
        style={{ width: 150 }}
        onChange={onChange}
        disabled={disabled}
      >
        <Option key="0" value="7 derniers jours">
          7 derniers jours
        </Option>
        <Option key="1" value="28 derniers jours">
          28 derniers jours
        </Option>
        <Option key="2" value="2 derniers mois">
          2 derniers mois
        </Option>
        <Option key="6" value="6 derniers mois">
          6 derniers mois
        </Option>
      </Select>
    </div>
  );
};
export default FilterDates;
